export const generateReadMore = (readMore, readMoreContent) => readMore && readMore.isEnabled && readMoreContent ? {
  ...readMore,
  content: readMoreContent
} : null;
export const getProductReadMoreModalName = productName => productName ? `${productName}.readMore` : null;